import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MODE,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": MODEL_ID.TENCENT_MESH_SEGMENTATION_PRO,
  "provider": PROVIDER.TENCENT,
  "action": ACTION.MESH_SEGMENTATION,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "input_3d": {
        "type": "string",
        "allowedTypes": ['glb', 'gltf', 'fbx', 'obj', 'stl'],
        "maxFileSize": 200 * 1024 * 1024,
      },
    },
    "required": ["input_3d"],
    "additionalProperties": false,
  },
  "active_if": {},
}
